import { Children, PropsWithChildren } from 'react';
import { ACTOR_INFO } from '../../constants/conversation';
import { ActorType } from '../../enums/conversation';
import { Message } from '../Message/index.types';
import BotBubble from './Bot';
import UserBubble from './User';
import { Actor } from './index.types';

type BubbleProps = PropsWithChildren & {
    actor: Actor;
    className?: string;
    timestamp?: Message['createdAt'];
};

function MessageBubble({ actor, children, className, timestamp }: BubbleProps) {
    if (actor.type === ActorType.USER)
        return (
            <UserBubble className={className} timestamp={timestamp}>
                {children}
            </UserBubble>
        );

    return (
        <BotBubble
            actorName={
                actor.type === ActorType.AGENT
                    ? `${actor.firstName} ${actor.lastName || ''}`
                    : ACTOR_INFO[ActorType.BOT].name
            }
            className={className}
            timestamp={timestamp}
        >
            {Children.map(Children.toArray(children), (child) => child && child)}
        </BotBubble>
    );
}

export default MessageBubble;
